// extracted by mini-css-extract-plugin
module.exports = {"recentArticleContainer":"index-module_recentArticleContainer_13m7C","itemContainer":"index-module_itemContainer_YcICc","itemTitle":"index-module_itemTitle_39czT"};